export function skipFrames(frameCount, callback) {
    if (frameCount == 0) {
        callback();
    }
    else {
        requestAnimationFrame(function () { return skipFrames(frameCount - 1, callback); });
    }
}
